export default angular.module('mars.vet.dnareports.services.breedcluster', []).factory('BreedClusterService', function(reportdata) {
  'ngInject';
 var getClusterCount = function() {
  var breedData = [];
  var clusterData = {};

  angular.forEach(reportdata.resultString.resultCalls, function(value, key) {
   if (!(breedData.includes(value['breed']))) {
    breedData.push(value['breed']);
   }
  });

  angular.forEach(breedData, function(value, key) {
   if (value.indexOf('^') > 1) {
    var breedCluster = value.split('^');
    if (clusterData[breedCluster[0]]) {
     ++clusterData[breedCluster[0]];
    } else {
     clusterData[breedCluster[0]] = 1
    }
   }
  });
  return clusterData;
 };

 return {
  getBreedClusterCount: getClusterCount
 };

}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/breedcluster.service.js